import { Link } from 'react-router-dom';
import { siteStats, popularTags, friendLinks } from '@/mocks/home';

export default function HomeAbout() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200/70">
      <div className="shell py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-6 h-px bg-accent-500"></span>
              <span className="text-[11px] tracking-[0.24em] uppercase text-accent-600 font-label">
                About Ruri Shrine
              </span>
            </div>
            <h2 className="text-xl md:text-3xl font-semibold leading-relaxed">
              在这里，认真地喜欢动画
            </h2>
            <p className="mt-4 text-sm md:text-[15px] leading-7 md:leading-8 text-foreground-700 max-w-2xl">
              琉璃神社是一个由爱好者组成的内容编辑团队。我们不追逐流量式的快讯，而是希望每一条资讯都能被放进作品的脉络里，每一个专题都能留下一点可被反复阅读的东西。
            </p>
            <p className="mt-3 text-sm md:text-[15px] leading-7 md:leading-8 text-secondary-600 max-w-2xl">
              从新番动态到产业数据，从分镜语言到同人生态——热爱需要被认真对待，也值得被好好记录。
            </p>

            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {siteStats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-background-200/80 bg-background-50 px-3 py-3"
                >
                  <p className="text-lg md:text-xl font-label text-primary-700 tracking-wide">
                    {stat.value}
                  </p>
                  <p className="mt-1 text-[11px] text-secondary-500">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解我们
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
              <Link
                to="/category/culture"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                阅读文化专题
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-200/80 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20quiet%20reading%20corner%20with%20tall%20wooden%20bookshelves%2C%20a%20low%20table%20with%20tea%20and%20open%20books%2C%20large%20window%20showing%20teal%20dusk%20sky%2C%20warm%20amber%20lamp%20glow%2C%20painterly%20digital%20art%2C%20cozy%20detailed%20interior%2C%20clean%20composition&width=1200&height=900&seq=home-reading-corner&orientation=landscape"
                alt="琉璃神社阅读空间插画"
                title="琉璃神社 - 动漫文化交流空间"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="mt-2.5 text-[11px] text-secondary-400 text-center">
              阅读角落 · 演示插图
            </p>
          </div>
        </div>

        <div className="mt-9 pt-7 border-t border-background-200/70 flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
          <div className="flex-1">
            <p className="text-[11px] tracking-[0.2em] uppercase text-secondary-500 font-label mb-3">
              热门标签
            </p>
            <div className="flex flex-wrap gap-2">
              {popularTags.map((tag) => (
                <Link
                  key={tag}
                  to={`/search?q=${encodeURIComponent(tag)}`}
                  className="px-3 py-1.5 rounded-full border border-background-300 bg-background-50 text-xs text-foreground-700 hover:border-accent-400 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  #{tag}
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-[300px] shrink-0">
            <p className="text-[11px] tracking-[0.2em] uppercase text-secondary-500 font-label mb-3">
              友情链接
            </p>
            <div className="flex flex-wrap gap-x-4 gap-y-2">
              {friendLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-xs text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  {link.label}
                  <i className="ri-arrow-right-up-line w-3 h-3 flex items-center justify-center text-secondary-400"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}